import React, { useContext, useState } from 'react';
import styles from './header.module.scss';
import { Button } from 'antd';
import { RestAPI, useBP, useEventListener } from 'scripts';
import { TbArrowRight, TbMoon, TbSquarePlus, TbSun, TbUserSquareRounded } from 'react-icons/tb';
import logo from 'assets/images/logo-small.png';
import { GlobalContext } from 'context';
import Image from 'next/image';
import { AppContextActionKeyEnum, ThemeEnum } from 'types';
import { API, PATH } from 'data';
import { COLORS } from 'utilities';
import { RxDashboard } from 'react-icons/rx';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { HiOutlineChatBubbleOvalLeftEllipsis } from 'react-icons/hi2';
import MegaMenuComp from './megaMenu/megaMenu.index';
import MyAccountMenuComp from './myAccountMenu/myAccountMenu.index';
import AppLinkComp from 'components/appLink/appLink.index';
import { __HeaderPropsType } from './header.type';
import HeaderSearchComp from './search/search.index';
import { usePathname } from 'next/navigation';
import { __PanelNoMenuRoutes } from 'aloEjare/panel/panel.data';
import { matchPath } from 'react-router-dom';

export default function HeaderComp(props: __HeaderPropsType) {
    const [logoutLoad, setLogoutLoad] = useState(false);
    const [collapse, setCollapse] = useState(false);
    const { theme, update, profile, categories, parentLocations } = useContext(GlobalContext);
    const isMobile = useBP()?.LG_LTE;
    const pathname = usePathname();
    const showMenu = __PanelNoMenuRoutes.map((i) => !matchPath({ path: i, end: false }, pathname)).includes(false);
    const isPanel = pathname.startsWith(PATH.panel.index) && !showMenu;

    useEventListener('scroll', () => {
        if (window.scrollY > 0) setCollapse(true);
        else setCollapse(false);
    });

    const onThemeChange = () => {
        const newValue = theme === ThemeEnum.dark ? ThemeEnum.light : ThemeEnum.dark;
        update({ key: AppContextActionKeyEnum.theme, value: newValue });
        document.body.setAttribute('data-mode', newValue);
        RestAPI.post(API.middlewares.theme, { theme: newValue });
    };

    return (
        <header
            className={`${styles['header']} ${collapse ? styles['collapsed'] : ''} ${props.showHeaderInMobile ? '' : 'd-pre-md-none'}
                         ${props.headerBgDarkInLightMode ? styles['bg-dark-mobile'] : ''}`}
        >
            <div className="h-100 main-content g-lg-3 g-pre-lg-2 center-content-y justify-content-between">
                <AppLinkComp href={PATH.home} className="align-items-center g-1 d-pre-md-none">
                    <Image src={logo} alt="تیک سبز" width={50} height={50} />
                </AppLinkComp>
                {props.hasBackButton ? (
                    <Button
                        className="d-md-none"
                        icon={<TbArrowRight />}
                        type="text"
                        onClick={() => {
                            window.history.back();
                        }}
                    />
                ) : null}
                <HeaderSearchComp
                    parentLocations={parentLocations}
                    search={props.search}
                    noLocation={props.noLocation}
                />
                <div className="flex-1 g-1 justify-content-between center-content-y d-pre-md-none">
                    <div className={`${styles['header-menu']}  ${styles['category-btn']} center-content-y pointer`}>
                        <RxDashboard size={16} color={theme === ThemeEnum.light ? COLORS.black2 : COLORS.gray2} />
                        <p className={`t-p1 t-400 t-l-black1 t-d-gray3 ${styles['text']}`}>دسته ها</p>
                        <MdKeyboardArrowDown
                            size={16}
                            color={theme === ThemeEnum.light ? COLORS.black2 : COLORS.gray2}
                        />
                        <MegaMenuComp
                            categories={categories}
                            className={`${styles['display-status']} ${collapse ? styles['collapse'] : ''}`}
                        />
                    </div>
                    {profile ? (
                        <div
                            className={`${styles['header-menu']} ${logoutLoad ? styles['active'] : ''} 
                                            ${styles['panel-item']} center-content pointer`}
                        >
                            <TbUserSquareRounded
                                size={16}
                                color={theme === ThemeEnum.light ? COLORS.black2 : COLORS.gray2}
                            />
                            <p className={`t-p1 t-400 t-l-black1 t-d-gray3 ${styles['text']}`}>حساب من</p>
                            {isPanel ? null : (
                                <MyAccountMenuComp
                                    className={`${styles['panel-menu-status']}`}
                                    setLogoutLoad={setLogoutLoad}
                                />
                            )}
                        </div>
                    ) : (
                        <AppLinkComp href={PATH.login()}>
                            <div className={`${styles['header-menu']} ${styles['panel-item']} center-content pointer`}>
                                <TbUserSquareRounded
                                    size={16}
                                    color={theme === ThemeEnum.light ? COLORS.black2 : COLORS.gray2}
                                />
                                <p className={`t-p1 t-400 t-l-black1 t-d-gray3 ${styles['text']}`}>ورود</p>
                            </div>
                        </AppLinkComp>
                    )}
                    <AppLinkComp href={PATH.panel.chat()}>
                        <div className={`${styles['header-menu']} center-content`}>
                            <HiOutlineChatBubbleOvalLeftEllipsis
                                size={16}
                                color={theme === ThemeEnum.light ? COLORS.black2 : COLORS.gray2}
                            />
                            <p className={`t-p1 t-400 t-l-black1 t-d-gray3 ${styles['text']}`}>چت</p>
                        </div>
                    </AppLinkComp>
                </div>
                <div className="g-1 d-pre-md-none">
                    <Button className="ph-2-i" type="primary" onClick={onThemeChange}>
                        {theme === ThemeEnum.dark ? <TbSun /> : <TbMoon />}
                    </Button>
                    <AppLinkComp href={!profile ? PATH.login(PATH.panel.addPost.index()) : PATH.panel.addPost.index()}>
                        <Button icon={<TbSquarePlus size={20} />}>{isMobile ? null : 'ثبت آگهی'}</Button>
                    </AppLinkComp>
                </div>
            </div>
        </header>
    );
}
